module.exports = __webpack_public_path__ + "img/naked-insurance-banner-square-4.93a112b8.jpg";